/* unplugin-vue-components disabled */import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_i_link = _resolveComponent("i-link");
  var _component_i_menu_side_item = _resolveComponent("i-menu-side-item");
  var _component_i_menu_side_submenu = _resolveComponent("i-menu-side-submenu");
  var _component_Tooltip = _resolveComponent("Tooltip");
  var _component_i_menu_side_collapse = _resolveComponent("i-menu-side-collapse");
  var _component_Menu = _resolveComponent("Menu");
  var _directive_color = _resolveDirective("color");
  var _directive_bold = _resolveDirective("bold");
  var _directive_font = _resolveDirective("font");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: _normalizeClass(["i-layout-sider-logo", {
      'i-layout-sider-logo-dark': _ctx.siderTheme === 'dark'
    }])
  }, [_createVNode(_Transition, {
    name: "fade-quick"
  }, {
    default: _withCtx(function () {
      return [!$props.hideLogo ? (_openBlock(), _createBlock(_component_i_link, {
        key: 0,
        to: "/"
      }, {
        default: _withCtx(function () {
          return [_createCommentVNode("                    <img src=\"@/assets/images/logo-small.png\" v-if=\"menuCollapse\">"), _createCommentVNode("                    <img src=\"@/assets/images/logo.png\" v-else-if=\"siderTheme === 'light'\">"), _createCommentVNode("                    <img src=\"@/assets/images/logo-dark.png\" v-else>"), _withDirectives((_openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString($options.layout.title), 1 /* TEXT */)])), [[_directive_color, $options.layout.headerTheme === 'dark' ? '#fefefe' : '#515a6e'], [_directive_bold], [_directive_font, 18]])];
        }),
        _: 1 /* STABLE */
      })) : _createCommentVNode("v-if", true)];
    }),
    _: 1 /* STABLE */
  })], 2 /* CLASS */), _createVNode(_component_Menu, {
    ref: "menu",
    class: _normalizeClass(["i-layout-menu-side i-scrollbar-hide", {
      'i-layout-menu-side-collapse': _ctx.menuCollapse
    }]),
    theme: _ctx.siderTheme,
    accordion: _ctx.menuAccordion,
    "active-name": _ctx.activePath,
    "open-names": _ctx.openNames,
    width: "auto"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterSider, function (item, index) {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [!_ctx.menuCollapse ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [item.children === undefined || !item.children.length ? (_openBlock(), _createBlock(_component_i_menu_side_item, {
          key: 0,
          menu: item
        }, null, 8 /* PROPS */, ["menu"])) : (_openBlock(), _createBlock(_component_i_menu_side_submenu, {
          key: 1,
          menu: item
        }, null, 8 /* PROPS */, ["menu"]))], 64 /* STABLE_FRAGMENT */)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [item.children === undefined || !item.children.length ? (_openBlock(), _createBlock(_component_Tooltip, {
          content: _ctx.tTitle(item.title),
          placement: "right",
          key: index,
          theme: _ctx.siderTheme
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_i_menu_side_item, {
              class: "i-layout-menu-side-collapse-top-item",
              menu: item,
              "hide-title": ""
            }, null, 8 /* PROPS */, ["menu"])];
          }),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["content", "theme"])) : (_openBlock(), _createBlock(_component_i_menu_side_collapse, {
          key: 1,
          menu: item,
          "top-level": ""
        }, null, 8 /* PROPS */, ["menu"]))], 64 /* STABLE_FRAGMENT */))], 64 /* STABLE_FRAGMENT */);
      }), 128 /* KEYED_FRAGMENT */))];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "theme", "accordion", "active-name", "open-names"])]);
}